import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { usePage, router } from '@inertiajs/react';
import Layout from './Layout';
import Preview from './Preview';
const PhotoUploader = ({}) => {
    const { t } = useTranslation();
    const csrf_token = (usePage().props?._token || '');
    const getUploadParams = ({ file, }) => {
        const body = new FormData();
        body.append('file', file);
        body.append('_token', csrf_token);
        return {
            url: '/inbreuken/afbeelding-toevoegen',
            body,
        };
    };
    const handleSubmit = (files, allFiles) => {
        removeAllFiles(allFiles);
        router.replace('/inbreuken/afbeeldingen');
    };
    return (_jsx(Dropzone, { getUploadParams: getUploadParams, LayoutComponent: Layout, inputContent: t('copyright_checker.upload.inputContent'), inputWithFilesContent: t('copyright_checker.upload.inputWithFilesContent'), maxSizeBytes: 5_000_000, accept: "image/png,image/jpeg", submitButtonContent: t('copyright_checker.upload.submitButtonContent'), onSubmit: handleSubmit, canRemove: false, canCancel: false, canRestart: false, PreviewComponent: Preview }));
};
function removeAllFiles(files) {
    files.forEach(removeFile);
}
function removeFile(file) {
    try {
        file.remove();
    }
    catch (e) { }
}
export default PhotoUploader;
